module.exports = __webpack_public_path__ + "img/btn_google_light_normal_ios.b05c5b3d.svg";